import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatrixAnswer, MatrixConfig } from '../../models/questionnaire.model'

@Component({
  selector: 'app-matrix-input',
  templateUrl: './matrix-input.component.html',
  styleUrls: ['./matrix-input.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class MatrixInputComponent implements OnInit {
  @Input() config: MatrixConfig
  @Input() initialValue: Record<string, string> = {}
  @Input() initialSpecifyText: Record<string, string> = {}
  @Input() label: string = ''
  @Input() required: boolean = false
  @Input({ required: true }) scopeId!: string

  @Output() valueChanged = new EventEmitter<MatrixAnswer>()

  selections: Record<string, string> = {}
  specifyText: Record<string, string> = {}

  ngOnInit() {
    this.selections = { ...this.initialValue }
    this.specifyText = { ...this.initialSpecifyText }
  }

  rowName(rowKey: string): string {
    return `${this.scopeId}__${rowKey}`
  }

  onSelect(rowKey: string, columnKey: string): void {
    this.selections = { ...this.selections, [rowKey]: columnKey }
    this.emitValue()
  }

  onSpecifyTextChange(rowKey: string, event: Event): void {
    const text = (event.target as HTMLInputElement).value
    this.specifyText = { ...this.specifyText, [rowKey]: text }
    this.emitValue()
  }

  isSelected(rowKey: string, columnKey: string): boolean {
    return this.selections[rowKey] === columnKey
  }

  hasSelection(rowKey: string): boolean {
    return !!this.selections[rowKey]
  }

  private emitValue(): void {
    this.valueChanged.emit({
      selections: this.selections,
      specifyText: this.specifyText
    })
  }
}
